
import React from 'react';
import { useTournament } from '@/contexts/TournamentContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users } from 'lucide-react';

export const BenchDisplay: React.FC = () => {
  const { tournamentState } = useTournament();
  const { language } = useLanguage();
  
  const benchPlayers = tournamentState.players.filter(p => p.isOnBench);
  
  if (benchPlayers.length === 0) return null;
  
  return (
    <Card className="border-orange-200 bg-orange-50">
      <CardHeader className="bg-orange-100 py-3">
        <CardTitle className="text-orange-800 flex items-center gap-2 text-sm">
          <Users className="h-4 w-4" />
          {language === 'no' ? 'Benken' : 'Bench'}
        </CardTitle>
      </CardHeader>
      <CardContent className="py-3">
        <div className="flex flex-wrap gap-2">
          {benchPlayers.map((player) => (
            <div
              key={player.id}
              className="bg-orange-200 text-orange-800 px-3 py-1 rounded-full text-sm font-medium"
            >
              {player.name}
            </div>
          ))}
        </div>
        <p className="text-xs text-orange-600 mt-2">
          {language === 'no' 
            ? 'Disse spillerne spiller neste runde'
            : 'These players will play next round'}
        </p>
      </CardContent>
    </Card>
  );
};
